export default (http, resource, apiVersion) => ({
    signup(data) {
        const method = 'post';
        const url = `${apiVersion}/${resource}/signup`;
        return http({ method, url, data });
    },
    saveUserDetails(data) {
        const method = 'put';
        const url = `${apiVersion}/${resource}/social-signin`;
        return http({ method, url, data });
    }
});
